import React, { useEffect, useState } from "react"

import { formatDate } from 'helpers/helpers'
import { httpOk, GET, POST, DELETE } from 'helpers/api'

/**
 * Подключение телеграм-группы к своему бренду.
 *
 * Код выписывается на бренд того, кто нажал кнопку, живёт час и срабатывает
 * один раз. Ссылка нужна, когда бота в группе ещё нет — Telegram добавит его
 * сам; команда — когда бот уже сидит в группе и добавлять нечего.
 */
function TelegramGroupConnect({ title = 'Telegram-группа', bare = false }) {
	const [data, setData] = useState({ bot: '', can_manage: false, chats: [] })
	const [link, setLink] = useState(null)
	const [copied, setCopied] = useState(false)

	async function getData(showLoader = false) {
		const response = await GET('/telegram-manager/link', {}, { loader: showLoader })
		if (httpOk(response)) setData(response.data)
	}

	async function createLink() {
		const response = await POST('/telegram-manager/link', {}, { loader: true, notification: false })
		if (httpOk(response)) {
			setLink(response.data)
			setCopied(false)
		}
	}

	async function unlink(chatId) {
		const response = await DELETE('/telegram-manager/link', { chat_id: chatId }, { loader: true })
		if (httpOk(response)) getData()
	}

	useEffect(() => {
		getData()
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	// bare — вставка в чужую колонку (страница точки): без карточки и отступов
	const content = (
		<>
			<h5 className={bare ? 'fw-600' : ''}>{title}</h5>
				<p className="text-muted">
					Бот @{data.bot || 'mison_manager_bot'} выставляет счета прямо в вашей группе:
					команда <code>/pay</code> — счёт на оплату, <code>/info</code> — балансы филиалов.
				</p>

				{!data.can_manage &&
					<div className="text-muted">Подключить группу может владелец или директор.</div>
				}

				{data.can_manage &&
					<>
						<button type="button" className="btn btn-primary btn-rounded"
							onClick={() => createLink()}>
							<i className="uil-key-skeleton me-1"></i>
							Получить код
						</button>

						{link &&
							<div className="telegram-token-box mt-3">
								<div className="d-flex flex-wrap align-items-center gap-2">
									<a className="btn btn-success btn-sm" href={link.link} target="_blank" rel="noreferrer">
										<i className="uil-telegram-alt me-1"></i>
										Добавить бота в группу
									</a>
									<span className="text-muted">
										код действует до {formatDate(link.expires_at, 'dd.MM.yyyy HH:mm')}
									</span>
								</div>
								<div className="text-muted mt-2">
									Бот уже в вашей группе? Тогда просто отправьте в неё команду:
								</div>
								<div className="d-flex flex-wrap align-items-center gap-2 mt-1">
									<code className="flex-grow-1">{link.command}</code>
									<button type="button" className="btn btn-light btn-sm"
										onClick={() => { navigator.clipboard.writeText(link.command); setCopied(true) }}>
										{copied ? 'Скопировано' : 'Копировать команду'}
									</button>
								</div>
							</div>
						}
					</>
				}

				<div className="mt-3">
					<h6>Подключённые группы</h6>
					{(data.chats || []).length === 0
						? <div className="text-muted">Пока ни одна группа не подключена.</div>
						: <div className="table-responsive">
							<table className="table table-bordered mb-0">
								<thead>
									<tr>
										<th>Группа</th>
										<th>Филиал</th>
										<th className="text-nowrap">Подключена</th>
										{data.can_manage && <th className="text-end">Действие</th>}
									</tr>
								</thead>
								<tbody>
									{data.chats.map(item => (
										<tr key={item.chat_id}>
											<td>{item.title || item.chat_id}</td>
											<td>{item.pos_name || '—'}</td>
											<td className="text-nowrap">{formatDate(item.created_at, 'dd.MM.yyyy HH:mm')}</td>
											{data.can_manage &&
												<td className="text-end">
													<button type="button" className="btn btn-sm btn-outline-danger"
														onClick={() => unlink(item.chat_id)}>
														Отвязать
													</button>
												</td>
											}
										</tr>
									))}
								</tbody>
							</table>
						</div>
					}
				</div>
		</>
	)

	if (bare) {
		return <div className="mt-4">{content}</div>
	}

	return (
		<div className="card">
			<div className="card-body">{content}</div>
		</div>
	)
}

export default TelegramGroupConnect
